import { ca } from '@cian/analytics';

import { EBlockInPageName } from '../types/share';

export function trackChartSwipe(blockInPage: EBlockInPageName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'Swipe',
    label: blockInPage,
  });
}
